import { useGroupChannelContext } from '@sendbird/uikit-react/GroupChannel/context';
import React from 'react';
import { useDispatch } from 'react-redux';

import { MODAL_KEYS } from '_constants/modals';
import { hideSearch, resetCurrentMessage, setCurrentMessage } from '_store/chat/slice';
import { hideModal } from '_store/modals/slice';

import MessageSearchPannel from './LibMessageSearch';

const CustomSearchPannel = () => {
  const dispatch = useDispatch();
  const { channelUrl } = useGroupChannelContext();

  const handleResultClick = (message) => {
    dispatch(setCurrentMessage(message));
    dispatch(hideModal({ key: MODAL_KEYS.chatMessageSearch }));
  };

  const handleResetClick = () => {
    dispatch(resetCurrentMessage());
  };

  const handleCloseClick = () => {
    dispatch(hideSearch());
    dispatch(resetCurrentMessage());
    dispatch(hideModal({ key: MODAL_KEYS.chatMessageSearch }));
  };

  return (
    <MessageSearchPannel
      channelUrl={channelUrl}
      onResultClick={handleResultClick}
      onResetClick={handleResetClick}
      onCloseClick={handleCloseClick}
    />
  );
};

export default CustomSearchPannel;
